interface IBookingTranslationTypes {
  booking: string;
  bookingActivity: string;
  bookingCamp: string;
}

export const BookingTranslationTypes: IBookingTranslationTypes = {
  booking: "booking",
  bookingActivity: "bookingActivity",
  bookingCamp: "bookingCamp",
};
